import { QueryClient } from '@tanstack/react-query';

import { useNonBenefitMedicinesForSeoQuery } from '@/hooks/nonBenefit/nonBenefit.gql.impl';
import { NonBenefitMedicines } from '@/models/nonBenefit';
import { parseNonBenefitMedicinesForSeo } from '@/parsers/nonBenefit';

const useNonBenefitMedicinesForSeo = () => {
  const { data: nonBenefitMedicines = new NonBenefitMedicines([]), isLoading } =
    useNonBenefitMedicinesForSeoQuery(
      {},
      {
        select: parseNonBenefitMedicinesForSeo,
        refetchOnMount: false,
      },
    );

  return {
    isLoading,
    nonBenefitMedicines,
  };
};

const fetchQuery = async (queryClient: QueryClient) => {
  const response = await queryClient.fetchQuery(
    useNonBenefitMedicinesForSeoQuery.getKey({}),
    useNonBenefitMedicinesForSeoQuery.fetcher({}),
  );

  return parseNonBenefitMedicinesForSeo(response);
};

export default useNonBenefitMedicinesForSeo;

useNonBenefitMedicinesForSeo.fetchQuery = fetchQuery;
